import { Component, type ReactNode } from "react";

/** A failed recovery-options chunk must never take the conversation down. */
export class FailureRecoveryBoundary extends Component<
  { children: ReactNode; fallback: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
